import React from 'react';


export const SidebarData = [
  {
    title: 'Home',
    path: '/dashboard/home',
    
    cName: 'nav-text'
  },
  {
    title: 'Interested',
    path: '/dashboard/interest',
 
    cName: 'nav-text'
  },
  {
    title: 'Likes',
    path: '/dashboard/like',
  
    cName: 'nav-text'
  },
  {
    title: 'MyHomes',
    path: '/dashboard/myland',
    cName: 'nav-text'
  },
  
];
